class Deal {
    id=0;
    createdAt=0;
    updatedAt=0;
    title= "";
    contactId=0;
    contactName="";
    stageId=0;
    pipelineId=0;
    statusId=1; //
    ownerId=0;
    creatorId=0;
    contact={id:null,name:"",phone:""};
    
   

}


export default Deal;
